import {Card} from 'react-bootstrap'

// sources
import profile from '../img/dev.png'
const Name = () => {
    return (
      <>
        <Card className="text-center customCard" border='primary'>
          <Card.Img variant="top rounded-circle img-fluid img-maxed card-img-center-50" src={profile} />          
          <Card.Body>
            <Card.Title className={'mod_card1'} as={'h4'}><b>ANTHONER</b> MONZON</Card.Title>
            <Card.Text>SENIOR SOFTWARE ENGINEER <br/>VIDEO EDITOR</Card.Text>
          </Card.Body>
        </Card>
      </>
    );
}

export default Name;